import { addMinutes, addMonths, isAfter } from 'date-fns'

import { VisitorType } from '../enums'

export abstract class ExpirableData {
  expirationDate: Date

  constructor(expirationDate: Date = new Date()) {
    this.expirationDate = expirationDate
  }

  isExpired = (): boolean => isAfter(new Date(), new Date(this.expirationDate))

  abstract resetExpirationDate(): void
}

export class FirstVisitData extends ExpirableData {
  resetExpirationDate(): FirstVisitData {
    this.expirationDate = addMinutes(new Date(), 30)

    return this
  }
}

export class FirstVisitDataMapper {
  static toJSON: (firstvisitData: FirstVisitData) => string = JSON.stringify

  static fromJSON = (json: string | undefined | null): FirstVisitData => {
    const result = new FirstVisitData(new Date())
    result.resetExpirationDate()

    if (!json) {
      return result
    }

    try {
      Object.assign(result, JSON.parse(json))

      if (!result.expirationDate) {
        result.resetExpirationDate()
      }

      return result
    } catch {
      return result
    }
  }
}

export class VisitorTypeData extends ExpirableData {
  visitorType: VisitorType

  constructor(expirationDate: Date, visitorType: VisitorType) {
    super(expirationDate)
    this.visitorType = visitorType
  }

  setVisitorType(visitorType: VisitorType): VisitorTypeData {
    this.visitorType = visitorType

    return this
  }

  resetExpirationDate(): VisitorTypeData {
    this.expirationDate = addMonths(new Date(), 12)

    return this
  }
}

export class VisitorTypeDataMapper {
  static toJSON: (visitorTypeData: VisitorTypeData) => string = JSON.stringify

  static fromJSON = (json: string | undefined | null): VisitorTypeData => {
    const result = new VisitorTypeData(new Date(), VisitorType.NEW_USER)
    result.resetExpirationDate()

    if (!json) {
      return result
    }

    try {
      return Object.assign(result, JSON.parse(json))
    } catch {
      return new VisitorTypeData(new Date(), VisitorType.NEW_USER).resetExpirationDate()
    }
  }
}

export class EmailData extends ExpirableData {
  readonly email: string

  constructor(email: string) {
    super()
    this.email = email
    this.resetExpirationDate()
  }

  resetExpirationDate(): EmailData {
    this.expirationDate = addMonths(new Date(), 12)

    return this
  }
}

export class EmailDataMapper {
  static toJSON: (emailData: EmailData) => string = JSON.stringify

  static fromJSON = (json: string): EmailData => Object.assign(new EmailData(''), JSON.parse(json))
}

export class ClidData extends ExpirableData {
  clid: string

  constructor(expirationDate: Date, clid: string) {
    super(expirationDate)
    this.clid = clid
  }

  resetExpirationDate(): ClidData {
    this.expirationDate = addMinutes(new Date(), 30)

    return this
  }
}

export class ClidDataMapper {
  static toJSON: (clidData: ClidData) => string = JSON.stringify

  static fromJSON = (json: string | undefined | null): ClidData => {
    const result = new ClidData(new Date(), '')
    result.resetExpirationDate()

    if (!json) {
      return result
    }

    try {
      return Object.assign(result, JSON.parse(json))
    } catch {
      return new ClidData(new Date(), '').resetExpirationDate()
    }
  }
}

export class GclidData extends ExpirableData {
  gclid: string

  constructor(expirationDate: Date, gclid: string) {
    super(expirationDate)
    this.gclid = gclid
  }

  resetExpirationDate(): GclidData {
    this.expirationDate = addMinutes(new Date(), 30)

    return this
  }
}

export class GclidDataMapper {
  static toJSON: (clidData: GclidData) => string = JSON.stringify

  static fromJSON = (json: string | undefined | null): GclidData => {
    const result = new GclidData(new Date(), '')
    result.resetExpirationDate()

    if (!json) {
      return result
    }

    try {
      return Object.assign(result, JSON.parse(json))
    } catch {
      return new GclidData(new Date(), '').resetExpirationDate()
    }
  }
}

export class CrmData extends ExpirableData {
  crm: string

  constructor(expirationDate: Date, crm = '') {
    super(expirationDate)
    this.crm = crm
  }

  resetExpirationDate(): CrmData {
    this.expirationDate = addMinutes(new Date(), 30)

    return this
  }
}

export class CrmDataMapper {
  static toJSON: (crmData: CrmData) => string = JSON.stringify

  static fromJSON = (json: string | undefined | null): CrmData => {
    const result = new CrmData(new Date())

    result.resetExpirationDate()

    if (!json) {
      return result
    }

    try {
      return Object.assign(result, JSON.parse(json))
    } catch {
      return new CrmData(new Date()).resetExpirationDate()
    }
  }
}

export class ZaidData extends ExpirableData {
  zaid: string

  constructor(expirationDate: Date, zaid: string) {
    super(expirationDate)
    this.zaid = zaid
  }

  resetExpirationDate(): ZaidData {
    this.expirationDate = addMinutes(new Date(), 30)

    return this
  }
}

export class ZaidDataMapper {
  static toJSON: (zaidData: ZaidData) => string = JSON.stringify

  static fromJSON = (json: string | undefined | null): ZaidData => {
    const result = new ZaidData(new Date(), '')
    result.resetExpirationDate()

    if (!json) {
      return result
    }

    try {
      return Object.assign(result, JSON.parse(json))
    } catch {
      return new ZaidData(new Date(), '').resetExpirationDate()
    }
  }
}
